<template>
	<div class="OrdersView">
		<div class="columns is-mobile">
			<aside class="column is-fullheight-desktop is-two-fifths-desktop OrdersView__Aside">
				<div class="OrdersView__Tables">
					<nav class="tabs is-boxed">
						<ul>
							<li :class="{ 'is-active': currentTab === 'pending' }" @click="selectTab('pending')">
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.pending) }}</a>
							</li>
							<li :class="{ 'is-active': currentTab === 'new' }" @click="selectTab('new')">
								<a>
									{{ capitalizeFirstLetter(config.orderStatusNames.new) }}
									<!-- <b-tag rounded type="is-primary">{{ totalNewOrders }}</b-tag> -->
								</a>
							</li>
							<li :class="{ 'is-active': currentTab === 'planned' }" @click="selectTab('planned')">
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.planned) }}</a>
							</li>
							<li
								v-if="config.isInProductionStatusEnabled"
								:class="{ 'is-active': currentTab === 'inProduction' }"
								@click="selectTab('inProduction')"
							>
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.inProduction) }}</a>
							</li>
							<li :class="{ 'is-active': currentTab === 'sent' }" @click="selectTab('sent')">
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.sent) }}</a>
							</li>
							<li
								:class="{ 'is-active': currentTab === 'archived' }"
								@click="selectTab('archived')"
							>
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.archived) }}</a>
							</li>
							<li
								v-if="config.canMoveToComplaints"
								:class="{ 'is-active': currentTab === 'complaint' }"
								@click="selectTab('complaint')"
							>
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.complaint) }}</a>
							</li>
							<li
								v-if="config.canMoveToTrash"
								:class="{ 'is-active': currentTab === 'trashed' }"
								@click="selectTab('trashed')"
							>
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.trashed) }}</a>
							</li>
							<li :class="{ 'is-active': currentTab === 'all' }" @click="selectTab('all')">
								<a>{{ capitalizeFirstLetter(config.orderStatusNames.all) }}</a>
							</li>
						</ul>
					</nav>

					<div class="level">
						<b-field
							horizontal
							label="Kraj"
							v-if="
								config.isFilterByCountryEnabled &&
								(currentTab === 'pending' || currentTab === 'new')
							"
							class="view-mode-toggle level-left"
						>
							<b-field class="field-body" grouped>
								<b-select
									placeholder="Wybierz kraj"
									:value="filterCountry"
									@input="selectFilterCountry"
								>
									<option :value="null">dowolny</option>
									<option value="PL">Polska</option>
									<option value="CZ">Czechy</option>
									<option value="SK">Słowacja</option>
									<option value="RO">Rumunia</option>
									<option value="HU">Węgry</option>
									<option value="DE">Niemcy</option>
									<option value="AT">Austria</option>
									<option value="HR">Chorwacja</option>
								</b-select>
							</b-field>
						</b-field>

						<b-field
							horizontal
							label="Widok"
							v-if="currentTab !== 'pending' && currentTab !== 'new'"
							class="view-mode-toggle level-left"
						>
							<b-field>
								<b-radio-button :value="viewMode" native-value="orders" @input="selectViewMode">
									<span>Zamówienia</span>
								</b-radio-button>
								<b-radio-button :value="viewMode" native-value="routes" @input="selectViewMode">
									<span>Trasy</span>
								</b-radio-button>
							</b-field>
						</b-field>

						<b-field grouped class="level-right search-field">
							<div class="control is-clearfix">
								<input
									placeholder="Imię nazwisko, tel, NR zam."
									type="search"
									class="input"
									v-model="searchText"
									@keyup.enter="search(searchText)"
									@input="checkIsSearchReseted"
								/>
							</div>
							<p class="control">
								<button class="button is-primary" @click="search(searchText)">Szukaj</button>
							</p>
						</b-field>
					</div>

					<orders-table
						v-show="viewMode === 'orders' || currentTab === 'new'"
						@update:checkedRows="ordersTableRowSelect"
						@order-click="$emit('order-click', $event)"
						@route-click="$emit('route-click', $event)"
					/>

					<routes-table
						v-show="viewMode === 'routes' && currentTab !== 'new'"
						@update:checkedRows="routesTableRowSelect"
						@route-click="$emit('route-click', $event)"
					/>
				</div>
				<Footer />
			</aside>
			<div class="column OrdersView__Map">
				<Map @order-click="$emit('map-order-click', $event)" />
			</div>
		</div>
	</div>
</template>

<script>
import bus from '@/EventBus'
import config from '@/config'
import { mapState } from 'vuex'
import OrdersTable from '@/components/tables/OrdersTable'
import RoutesTable from '@/components/tables/RoutesTable'
import Map from '@/components/Map'
import Footer from '@/components/Footer'

export default {
	name: 'OrdersView',
	components: {
		OrdersTable,
		RoutesTable,
		Map,
		Footer
	},
	data() {
		return {
			totalNewOrders: null,
			totalPendingOrders: null,
			searchText: ''
		}
	},
	computed: {
		...mapState('orders', ['currentTab', 'viewMode', 'filterCountry']),
		config() {
			return config.company
		}
	},
	methods: {
		addTestOrder() {
			const testOrder = {
				clientName: 'Jan Kowalski',
				postalCode: '12-123',
				post: 'Gdańsk',
				phone: '123-561-345',
				broker: 'pośrednik ABC',
				isInvoice: false,
				creator: 3
			}
			this.isLoading = true
			this.$store
				.dispatch('orders/createOrder', testOrder)
				.then((order) => {
					this.isLoading = false
					this.$snackbar.open(`Zamówienie #${order.id} zostało dodane.`)
					bus.$emit('order-created')
				})
				.catch((error) => {
					console.log('error', error)
					if (error.response.status === 400) {
						alert(
							error.response.data.violations[0].message +
								': ' +
								error.response.data.violations[0].propertyPath
						)
						// console.log('msgs', error.response.data.violations)
					}
				})
		},
		selectTab(tabName) {
			this.$store.dispatch('orders/selectTab', tabName)
		},
		selectViewMode(mode) {
			this.$store.dispatch('orders/selectViewMode', mode)
		},
		selectFilterCountry(filterCountry) {
			this.$store.dispatch('orders/selectFilterCountry', filterCountry)
		},
		search() {
			this.$store.dispatch('orders/search', this.searchText)
		},
		checkIsSearchReseted() {
			if (this.searchText === '') this.$store.dispatch('orders/search', this.searchText)
		},
		ordersTableRowSelect(rows) {
			bus.$emit('orders-table-row-select', rows)
		},
		routesTableRowSelect(rows) {
			bus.$emit('routes-table-row-select', rows)
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
		}
	},
	mounted() {
		this.selectTab('new')
	},
	created() {
		bus.$on('new-orders-loaded', (totalNewOrders) => {
			this.totalNewOrders = totalNewOrders
		})
	},
	destroyed() {
		bus.$off('tab-change')
	}
}
</script>

<style lang="scss">
.OrdersView {
	flex: 1 1 0;
	overflow: hidden;
	> .columns {
		height: 100%;
		margin: 0;
		@media (max-width: 1100px) {
			display: flex;
			flex-direction: column;
		}
		> * {
			padding: 0;
			@media (max-width: 1100px) {
				width: 100%;
			}
		}
	}
	&__Aside {
		overflow: auto;
	}
	&__Tables {
		padding: 10px;
		.table td,
		.table th {
			padding: 5px;
		}
		.tabs a {
			padding: 7px 10px;
			font-size: 13px;
		}
		.tabs li:first-child .tag {
			margin-left: 5px;
		}
		.view-mode-toggle {
			margin-bottom: 0 !important;
			.field-label {
				flex-grow: 0;
			}
		}
		.level {
			@media (max-width: 1366px) {
				flex-direction: column;
			}
			.level-left {
				@media (max-width: 1366px) {
					margin-bottom: 10px;
				}
			}
		}
		.level .field-label {
			@media (max-width: 1366px) {
				margin-right: 10px;
			}
		}
	}
	&__Map {
		background-color: rgb(223, 153, 153);
		border: 3px solid green;
		overflow: hidden;
	}
}
.modal .animation-content {
	width: 100%;
}
.search-field {
	margin-left: auto;
	.input {
		min-width: 280px;
	}
}
</style>
